import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchHouseDetail } from '@/api/PMS/houseDeliveryManage/deliveryRegistration';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: {
    showDialog: Boolean,
    deliveryObj: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      rules: {
        upIdList: [{
          required: true,
          message: '请选择房间',
          trigger: 'change'
        }],
        statusDate: [{
          required: true,
          message: '请选择交房日期',
          trigger: 'change'
        }]
      },
      loading: false,
      customerList: [],
      cascaderItem: [],
      houseList: [],
      childData: {},
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.loadMenuTree();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.customerList = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (Object.keys(this.deliveryObj).length > 0) {
        this.childData = this.deliveryObj;
      } else {
        this.childData = {};
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 0
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this3 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this3.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    // 检查是否选择下拉框是否选择正确的房间
    checkSelectHouse: function checkSelectHouse() {
      this.cascaderItem = [];
      this.$set(this.childData, 'customerName', '');
      this.$set(this.childData, 'customerId', '');
      this.getCascaderItem(this.childData.upIdList, this.options);

      if (this.cascaderItem[this.cascaderItem.length - 1].flag !== '211') {
        this.$message({
          message: '请选择正确的房间',
          type: 'error',
          duration: 3000
        });
        this.childData.upIdList = [];
        return false;
      }

      var houseId = this.childData.upIdList[this.childData.upIdList.length - 1];
      this.$set(this.childData, 'houseId', houseId);
      this.handleSelectHouse(houseId);
    },
    handleSelectHouse: function handleSelectHouse(houseId) {
      var _this4 = this;

      this.$set(this.childData, 'customerName', '');
      this.$set(this.childData, 'customerId', '');
      fetchHouseDetail({
        houseId: houseId
      }).then(function (res) {
        if (res.data.code === 200) {
          _this4.$set(_this4.childData, 'customerName', res.data.data.customerName);

          _this4.$set(_this4.childData, 'customerId', res.data.data.customerId);
        }
      });
    },
    handUpdate: function handUpdate() {
      var _this5 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this5.childData.houseStatus = 1;

          if (Object.keys(_this5.deliveryObj).length > 0) {
            fetchUpdate(_this5.childData).then(function () {
              _this5.$emit('handCancle', true);

              _this5.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this5.childData).then(function (res) {
              if (res.data.code === 200) {
                _this5.$emit('handCancle', true);

                _this5.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this5.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handBindingCancle: function handBindingCancle() {
      this.$emit('handCancle', 'binding');
    }
  }
};